import React, { Component } from 'react'
import MealSelect from './MealSelect'
import { HeaderView } from '@merchant-backend/common-components'
import { Link } from 'react-router'
import { JIAMENG_GOODS_PATH, JIA_MENG_GOODS_MANAGE_PATH } from '@constant'
import { isStoreAccount } from '@util'

export default class extends Component {
  render() {
    console.log(JIA_MENG_GOODS_MANAGE_PATH + '/6')
    const header = [
      <Link to={JIAMENG_GOODS_PATH}>商品管理</Link>,
      <Link to={JIA_MENG_GOODS_MANAGE_PATH + '/6'}>婚纱摄影</Link>,
      '添加直供商品'
    ]
    const isStore = isStoreAccount()
    return (
      <HeaderView
        title={isStore ? '添加直供商品' : '发布套餐'}
        header={isStore ? header : ''}
      >
        <MealSelect />
      </HeaderView>
    )
  }
}
